<script>
	import Page from "#/layout/Page.svelte";
	import { Error } from "#/lib/icons.ts";
	import { container, panel } from "#/lib/panel.module.css";
</script>

<Page icon={Error} title="Not Found">
	<div class={container}>
		<div class={panel}>
			<p>welp.</p>
		</div>
	</div>
</Page>
